<template>
  <a class="link-button -type04">{{ title }}
    <img
      :src="`${userOfferImageUrlForSp}/icon_arrow_right_black.png`"
      class="arrow-image"
    >
  </a>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/common/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  mixins: [jobPreviewCommon],
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
